module.exports = __webpack_public_path__ + "static/muli-v16-latin-regular-534ccefddf10905f72d5392c85c4227f.ttf";